import HomeContent from "../../components/Dashboard/Homecontent";
const Home = () => {
  return (
    <HomeContent />
  );
};

export default Home;
